import {
  IconButton,
  Stack,
  Dialog,
  DialogType,
  DialogFooter,
  PrimaryButton,
  DefaultButton,
  useTheme,
  TooltipHost,
} from '@fluentui/react';
import { useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { ApprovalValues } from '../../../types';
import { showCustomToast } from 'common/components/CustomToast/utils';
import { setNodeScrollState } from '../../Conditions';

export const DeleteTree: React.FC<{ data: any }> = ({ data }) => {
  const [showDialog, setShowDialog] = useState(false);
  const { getValues, setValue } = useFormContext<ApprovalValues>();
  const theme = useTheme();
  const onDelete = () => {
    const approvalTrees = getValues('approvalTrees') || [];
    let updatedTree: typeof approvalTrees;

    if (data.id) {
      updatedTree = approvalTrees.filter((item) => item.id !== data.id);
    } else {
      const {
        levelIndex,
        isFlowUpdatable,
        isFlowDeletable,
        ...dataWithoutLevelIndex
      } = data;

      const indexToRemove = approvalTrees.findIndex((item) =>
        Object.keys(dataWithoutLevelIndex).every(
          (key) =>
            item[key as keyof typeof item] ===
            dataWithoutLevelIndex[key as keyof typeof dataWithoutLevelIndex]
        )
      );
      updatedTree =
        indexToRemove !== -1
          ? [
              ...approvalTrees.slice(0, indexToRemove),
              ...approvalTrees.slice(indexToRemove + 1),
            ]
          : [...approvalTrees];
    }

    setValue('approvalTrees', updatedTree, {
      shouldDirty: true,
    });

    showCustomToast({
      content: 'Tree removed',
      appearance: 'info',
    });
    setNodeScrollState(true);
    setShowDialog(false);
  };

  return (
    <Stack>
      <TooltipHost content={'Delete'}>
        <IconButton
          iconProps={{ iconName: 'Delete' }}
          title="Delete Tree"
          ariaLabel="Delete Tree"
          onClick={() => {
            setNodeScrollState(false);
            setShowDialog(true);
          }}
          styles={{
            icon: {
              fontSize: 16,
              color: 'white',
            },
            iconHovered: {
              color: 'white',
            },
            rootDisabled: {
              backgroundColor: 'transparent',
            },
            rootHovered: { backgroundColor: theme.palette.themeDarkAlt },
            root: { height: 20, width: 20 },
          }}
          disabled={!(data.isFlowDeletable && data.isFlowUpdatable)}
        />
      </TooltipHost>

      {showDialog && (
        <Dialog
          hidden={false}
          onDismiss={() => {
            setNodeScrollState(true);
            setShowDialog(false);
          }}
          dialogContentProps={{
            type: DialogType.normal,
            title: 'Delete Tree',
            subText: 'Are you sure you want to delete this tree?',
          }}
        >
          <DialogFooter>
            <PrimaryButton onClick={onDelete} text="Delete" />
            <DefaultButton
              onClick={() => {
                setNodeScrollState(true);
                setShowDialog(false);
              }}
              text="Cancel"
            />
          </DialogFooter>
        </Dialog>
      )}
    </Stack>
  );
};
